import React from 'react';
import { Link } from 'react-router-dom';
import classes from './dashboardButtonCard.module.scss';

function DashboardButtonCard(props) {
  const { cardInfo } = props;

  return (
    <div
      className={classes.container}
      style={{
        backgroundImage: `url(${cardInfo.image})`
      }}
    >
      <div className={classes.gradient}>
        <Link to={cardInfo.link}>
          <div className={classes.textContent}>
            <h6>{cardInfo.title}</h6>
            <h3>{cardInfo.text}</h3>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default DashboardButtonCard;
